import { render, staticRenderFns } from "./dataprocess-form6.vue?vue&type=template&id=3f2e540a&scoped=true&"
import script from "./dataprocess-form6.vue?vue&type=script&lang=ts&"
export * from "./dataprocess-form6.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2e540a",
  null
  
)

export default component.exports